import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function N() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta2max.detail');

    return (
        <div
            className={`d2x-detail-N ${css.d2xDetailN} GtmModuleData-section`}
            id="d2x-detail-N"
            data-section-id={'d2x-detail-N'}
            data-section-title={t('sec14_title1')}
        >
            <div className="card card1">
                <div className="text-box">
                    <div className="title">{t('sec14_title1')}</div>
                    <div className="desc">{t('sec14_desc1')}</div>
                </div>
                <div className="img-box img-box1">
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/z5.webp')}
                        src={require('@publicLocal/delta2max/teaser/pc/eu/z5.jpg')}
                        alt={t('sec14_title1')}
                        aria-label={t('sec14_title1')}
                    />
                </div>
            </div>
            <div className="card card2">
                <div className="text-box">
                    <div className="title">{t('sec14_title2')}</div>
                </div>
                <div className="content">
                    <div className="left">
                        <div className="img-box img-box2">
                            <NextImage
                                webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/z6-1.webp')}
                                src={require('@publicLocal/delta2max/teaser/pc/eu/z6-1.jpg')}
                                alt={t('sec14_title2')}
                                aria-label={t('sec14_title2')}
                            />
                        </div>
                        <div className="img-desc">{t('sec14_card2_desc1')}</div>
                    </div>
                    <div className="right">
                        <div className="img-box img-box3">
                            <NextImage
                                webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/z6-2.webp')}
                                src={require('@publicLocal/delta2max/teaser/pc/eu/z6-2.jpg')}
                                alt={t('sec14_title2')}
                                aria-label={t('sec14_title2')}
                            />
                        </div>
                        <div className="img-desc">{t('sec14_card2_desc2')}</div>
                    </div>
                </div>
            </div>
            <div className="card card3">
                <div className="img-box img-box4">
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/z7.webp')}
                        src={require('@publicLocal/delta2max/teaser/pc/eu/z7.jpg')}
                        alt={t('sec14_title3')}
                        aria-label={t('sec14_title3')}
                    />
                </div>
                <div className="text-box">
                    <div className="title">{t('sec14_title3')}</div>
                    <div className="desc">{t('sec14_desc3')}</div>
                </div>
            </div>
            <div className="card card4">
                <div className="text-box">
                    <div className="title">{t('sec14_title4')}</div>
                    <div className="desc">
                        {t.rich('sec14_desc4', {
                            line: (text: any) => <span>{text}</span>,
                        })}
                    </div>
                    <div className="tip">{t('sec14_tip4')}</div>
                </div>
                <div className="img-box img-box5">
                    <NextImage
                        webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/z8.webp')}
                        src={require('@publicLocal/delta2max/teaser/pc/eu/z8.jpg')}
                        alt={t('sec14_title4')}
                        aria-label={t('sec14_title4')}
                    />
                </div>
            </div>
        </div>
    );
}
